import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { SlideDown } from 'react-slidedown';
import 'react-slidedown/lib/slidedown.css';
import { withTranslation } from 'react-i18next';
import { SDAC_EMAIL } from '../../constants';
import { mailto } from '../../js/utility';

import iconArrow from '../../images/icons/icon_32_rightchev.png';

class FaqItem extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
    };

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    this.setState((prevState) => ({
      isOpen: !prevState.isOpen,
    }));
  }

  render() {
    const { isOpen } = this.state;
    const { category, faqs, icon, t } = this.props;
    const search_replace_sdac_email = mailto(SDAC_EMAIL);
    return(
      <div className="fe-faq-item">
        <div
          onClick={this.handleClick}
          className="fe-faq-item-category"
        >
          <div className="fe-faq-item-heading">
            <img className="fe-faq-item-icon" src={icon} alt=""/>
            <h2>{ t(`support:${category}`) }</h2>
          </div>
          <img src={iconArrow} alt="" className={`fe-faq-item-arrow ${isOpen ? 'active' : ''}`} />
        </div>
        <SlideDown>
          {isOpen ?
            <div className="fe-faq-item-list">
              {faqs.map((faq, idx) => (
                <div key={idx} className="fe-faq-item-q-container">
                  <h4 className="fe-faq-item-q">{t(`support:${faq.question}`)}</h4>
                  <p
                    dangerouslySetInnerHTML={{ __html: search_replace_sdac_email(t(`support:${faq.answer}`)) }}
                    className="fe-faq-item-a"
                  />
                </div>
              ))}
            <p dangerouslySetInnerHTML={{__html:t(`support:sectionFooter`)}} />
            </div> :
            null}
        </SlideDown>
      </div>
    );
  }
}

FaqItem.propTypes = {
  category: PropTypes.string.isRequired,
  icon: PropTypes.string,
  faqs: PropTypes.arrayOf(PropTypes.object).isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(FaqItem);
